import '../styles/Architecture.scss';

import { Stack } from '@whistler-ui/k2/components/Stack';
import { Heading, Paragraph } from '@whistler-ui/k2/components/Typography';

import { useThemeStore } from '../../../store/theme';

const componentName = 'c-Architecture';

export function Architecture() {
  const { config } = useThemeStore();

  const image = config.assets.onboarding.architecture;

  return (
    <Stack
      tag="article"
      direction="row"
      gap={6}
      className={componentName}
      align="center"
    >
      <Stack direction="column" gap={8}>
        <Heading>System Architecture</Heading>
        <Stack direction="column" gap={4}>
          <Paragraph>
            Your entitlement server sits in between your customers’ devices and
            your OSS/BSS stack. This architecture allows those devices to
            interact with your OSS/BSS as required when providing the various
            mobile services to your customers.
          </Paragraph>
          <Paragraph>
            The connection between devices and the ES is used to choreograph
            different Use Cases like eSIM Transfer and Watch activation.
            Depending on the ecosystem this interface is either proprietary or
            follows GSMA TS.43.
          </Paragraph>
          <Paragraph>
            The connection between the ES and your OSS/BSS stack requires an
            integration on your part to implement a small set of granular APIs
            from our API specification. In most cases you will find that these
            APIs match quite closely what you already have deployed in your
            (Micro) Services layer.
          </Paragraph>
          <Paragraph>
            The remainder of this guide details how you can complete this work
            via this Developer Portal.
          </Paragraph>
        </Stack>
      </Stack>
      {image && (
        <aside>
          <img src={image} alt="architecture summary" />
        </aside>
      )}
    </Stack>
  );
}
